<template>
  <div class="service" v-if="user">
    <h3>Contact</h3>
    <div class="main">
      <div class="main-left">
        <img :src="user.member.avatarUrl" v-if="user.member.avatarUrl" />
        <img src="@/assets/img/avatar.png" v-else />
      </div>
      <div class="main-right">
        <p>
          <span>{{ user.companyUsers.linkNameEn }}</span
          ><i>{{ user.member.jobTitleEn }}</i>
        </p>
        <p>mobile：{{ user.companyUsers.phoneNumber }}</p>
        <p>E-email：{{ user.companyUsers.email }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["inMemberId"],
  data() {
    return {
      user: "",
    };
  },
  created() {
    console.log(this.inMemberId, "inMemberId");
    this.init();
    // this.ProductFollower("view");
  },
  methods: {
    ...mapActions({
      graphqlPostByZXS: "en/graphqlPostByZXS",
      // ProductFollower: "company/serviceFollower",
    }),
    async init() {
      let query = `
            query($id: String!){
                inMemberQuery{
                    get(id:$id){
                        companyUsers{
                            email
                            linkName
                            linkNameEn
                            phoneNumber
                        }
                        member{
                            avatarUrl
                            jobTitle
                            jobTitleEn
                        }
                    }
                }

            }
            `;
      let opt = {
        query: query,
        variables: {
          id: this.inMemberId,
        },
      };
      let res = await this.graphqlPostByZXS(opt);
      console.log(res, "----");
      if (res.data.inMemberQuery.get) {
        this.user = res.data.inMemberQuery.get;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.service {
  margin-top: -0.8rem;
  margin-bottom: 0.2rem;
  border-radius: 0.3rem;
  background: #fff;
  padding: 0.25rem;
  h3 {
    font-size: 0.3rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.2rem;
  }
  .main {
    display: flex;
    &-left {
      img {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        display: block;
        margin-right: 0.2rem;
      }
    }
    &-right {
      p {
        font-size: 0.28rem;
        line-height: 1.6;
        color: #666;
        span {
          font-size: 0.3rem;
          color: #333;
          font-weight: 600;
          margin-right: 0.1rem;
        }
        i {
          font-style: normal;
          font-size: 0.28rem;
        }
      }
    }
  }
}
</style>
